var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMaterial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2663 15.7325L12.8663 9.33167L11.6904 10.4967L7.51542 6.32167V2.85167L2.60625 0.0208333L0.0354167 2.59083L2.86708 7.5H6.33708L10.5063 11.6692L9.31375 12.85L15.7304 19.2675C16.2029 19.7392 16.8304 20 17.4988 20C18.1671 20 18.7946 19.74 19.2663 19.2675C20.2413 18.2925 20.2413 16.7075 19.2663 15.7325Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96042 12.8525L8.14625 11.6667L6.47208 9.9925L0.73125 15.7325C-0.24375 16.7075 -0.24375 18.2925 0.73125 19.2675C1.20375 19.7392 1.83125 20 2.49958 20C3.16792 20 3.79542 19.74 4.26708 19.2675L8.82125 14.7133L6.96042 12.8525Z",
    fill: "#363538"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2646 3.38167C19.7296 4.27917 19.9654 5.24417 19.9654 6.25C19.9654 8.37417 18.8979 10.2525 17.2729 11.3817L12.8721 6.98083L11.6954 8.145L9.18125 5.63083V1.9625C10.3213 0.7575 11.9288 0 13.7146 0C14.6988 0 15.6463 0.226667 16.5321 0.675833L16.7979 0.810833L13.8196 3.8225C13.1688 4.47333 13.1688 5.52833 13.8196 6.17917C14.4704 6.83 15.5254 6.83 16.1763 6.17917L19.1538 3.16917L19.2638 3.3825L19.2646 3.38167Z",
    fill: "#363538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaterial);
export default __webpack_public_path__ + "static/media/icon-material.2c3985a40e3f6069439f8c9f4a92c6d9.svg";
export { ForwardRef as ReactComponent };